import React, { useEffect, useMemo } from 'react';

export const HospitalStructuredData: React.FC = () => {
  const structuredData = useMemo(() => ({
    "@context": "https://schema.org",
    "@type": "Hospital",
    "name": "Divisional Hospital Weeraketiya",
    "alternateName": "ප්‍රාදේශීය රෝහල වීරකැටිය",
    "url": "https://weeraketiyahospital.lk",
    "logo": "https://weeraketiyahospital.lk/logo192.png",
    "description": "Quality healthcare services in Hambantota District, Sri Lanka. 24/7 Emergency services, OPD, ICU, Maternity, Pediatric care and specialized medical services.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Hospital Road",
      "addressLocality": "Weeraketiya",
      "addressRegion": "Hambantota",
      "postalCode": "",
      "addressCountry": "LK"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "6.3137",
      "longitude": "80.7489"
    },
    "telephone": "+94472246260",
    "email": "info@weeraketiyahospital.lk",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        "opens": "00:00",
        "closes": "23:59",
        "description": "24/7 Emergency Services"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "17:00",
        "description": "OPD Services"
      }
    ],
    "priceRange": "Free - Government Hospital",
    "medicalSpecialty": [
      "Emergency Medicine",
      "General Practice",
      "Obstetrics",
      "Pediatrics",
      "Surgery",
      "Intensive Care"
    ],
    "availableService": [
      {
        "@type": "MedicalProcedure",
        "name": "Emergency Treatment"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Outpatient Services"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Maternity Care"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Pediatric Care"
      },
      {
        "@type": "MedicalProcedure",
        "name": "ICU Services"
      }
    ],
    "sameAs": [
      "https://facebook.com/weeraketiyahospital",
      "https://twitter.com/weeraketiyahospital"
    ]
  }), []);

  useEffect(() => {
    // Add structured data to document head
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    script.id = 'hospital-structured-data';
    
    // Remove old script if exists
    const oldScript = document.getElementById('hospital-structured-data');
    if (oldScript) {
      oldScript.remove();
    }
    
    document.head.appendChild(script);
    
    return () => {
      // Cleanup on unmount
      const scriptToRemove = document.getElementById('hospital-structured-data');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [structuredData]);

  return null;
};

export default HospitalStructuredData;

